/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import * as Config from "./config";

async function reqNavigationRoutes(token) {
  const API_URI_NAVIGATION_ROUTES = Config.rutasCMS.navigation;
  try {
    const response = await axios.get(API_URI_NAVIGATION_ROUTES, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data.data.ruta;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqProductosAhorrroCredito(token) {
  const API_URI_PRODUCTOS_AHORRO_CREDITO =
    Config.rutasCMS.productosAhorroCredito;
  try {
    const response = await axios.get(API_URI_PRODUCTOS_AHORRO_CREDITO, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqBarraIntermedia(token) {
  const API_URI_BARRA_INTERMEDIA = Config.rutasCMS.barraIntermedia;
  try {
    const response = await axios.get(API_URI_BARRA_INTERMEDIA, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

async function reqMainMenuSections(token) {
  const API_URI_MAIN_MENU_ROUTES = Config.rutasCMS.mainMenuSections;
  try {
    const response = await axios.get(API_URI_MAIN_MENU_ROUTES, {
      headers: { Authorization: "Bearer " + token },
    });
    return response.data.data.aCSeccionMenuPrincipal;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export default {
  reqNavigationRoutes,
  reqProductosAhorrroCredito,
  reqBarraIntermedia,
  reqMainMenuSections,
};
